import { NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import logo from "../../images/FML.png";
import csrLogo from "../../images/CSR.jpg";
import csrbBg from "../../images/CSRB.png";
import "./Navbar.css";

export default function Navbar() {
  const { pathname } = useLocation();
  const isSports = pathname === "/csr";
  const [liveStatus, setLiveStatus] = useState({ home: false, csr: false });
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const checkLive = async () => {
      try {
        const res = await fetch("/api/live-status");
        const data = await res.json();
        setLiveStatus(data);
      } catch {
        setLiveStatus({ home: false, csr: false });
      }
    };

    checkLive();
    const interval = setInterval(checkLive, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <nav className={`navbar ${isSports ? "navbar--sports" : ""}`}
      style={isSports ? { backgroundImage: `url(${csrbBg})`, backgroundSize: "auto 260%", backgroundPosition: "right center", backgroundRepeat: "no-repeat" } : {}}>
      {isSports && <div className="navbar-sports-gradient" />}
      <div className="navbar-inner container">
        <NavLink to="/" className="navbar-logo">
          <img src={isSports ? csrLogo : logo} alt={isSports ? "Clarens Sportz Revive" : "KGubetswana FM"} className="navbar-logo-img" />
        </NavLink>
        <button
          className={`navbar-toggler ${menuOpen ? "collapsed" : ""}`}
          type="button"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
        >
          <span className={`navbar-toggler-icon ${menuOpen ? "open" : ""}`}>
            <span /><span /><span />
          </span>
        </button>
        <div className={`navbar-links ${menuOpen ? "open" : ""}`}>
          <NavLink to="/" end className="navbar-link-item" onClick={() => setMenuOpen(false)}>
            Home
            {liveStatus.home && <span className="navbar-live-badge">LIVE</span>}
          </NavLink>
          <NavLink to="/about" className="navbar-link-item" onClick={() => setMenuOpen(false)}>About Us</NavLink>
          <NavLink to="/csr" className="navbar-link-item" onClick={() => setMenuOpen(false)}>
            CSR
            {liveStatus.csr && <span className="navbar-live-badge">LIVE</span>}
          </NavLink>
          <NavLink to="/support" className="navbar-link-item" onClick={() => setMenuOpen(false)}>Support</NavLink>
        </div>
      </div>
    </nav>
  );
}
